// removed by extract-text-webpack-plugin
module.exports = {"PickupButtons":"PickupButtons__PickupButtons__1dGWh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PickupButtons/PickupButtons.css
// module id = 260
// module chunks = 1